export const banner = {
	backgroundColor: "red",
	color: "white",
	textAlign: "center",
	fontWeight: "bold",
	fontSize: "1rem",
};
